@if (isLoading()) {
    <app-loading
        class="m-auto"
        size="30" />
} @else {
    <app-custom-table
        class="h-full deposit-table-format"
        [columns]="customColumns()"
        [isSelectable]="false"
        [translateColumns]="true">
        @for (deposit of dataColumn(); track deposit.id) {
            <tr
                [class.!cursor-not-allowed]="deposit.status === Deposit.StatusEnum.ABORTED"
                [class.!cursor-pointer]="deposit.status !== Deposit.StatusEnum.ABORTED"
                [class.aborted-deposit-row]="deposit.status === Deposit.StatusEnum.ABORTED"
                [matTooltip]="
                    deposit.status === Deposit.StatusEnum.ABORTED ? ('depositWillBeReplaced' | transloco) : ''
                "
                [matTooltipDisabled]="deposit.status !== Deposit.StatusEnum.ABORTED"
                (click)="openDepositDetailPanel(deposit)">
                @for (column of customColumns(); track column.key) {
                    <td>
                        @if (column.key === 'status') {
                            <app-deposit-list-status
                                [deposit]="deposit"
                                [hasStandard]="!!depositFolder()?.standard"
                                [isValid]="managementDataService.checkIsValidDeposit(deposit, deposits())" />
                        } @else if (column.key === 'createdAt') {
                            {{ deposit.createdAt | date: translateService.localDate() }}
                        } @else {
                            {{ deposit[column.key] }}
                        }
                    </td>
                }
            </tr>
        } @empty {
            <tr>
                <td
                    class="text-center py-4 text-custom-extra-dark-grey"
                    [attr.colspan]="customColumns().length">
                    <div class="flex flex-row items-center justify-center">
                        <fa-icon
                            class="mr-4"
                            size="2x"
                            [class]="'text-custom-blue'"
                            [icon]="['fal', 'circle-exclamation']" />
                        <span class="text-headline-6">{{ 'noDepositOnProject' | transloco }}</span>
                    </div>
                </td>
            </tr>
        }
    </app-custom-table>
}
